import { Card, Space, Statistic } from 'antd';
import { round10 } from 'shared/utils/numbers/round';
import { ComparisonValue } from 'components/common/comparison-value';
import { STATISTICS } from './constants';
import styles from './distribution-efficiency-aggregated-statistic.module.scss';
import type { IDistributionEfficiencyAggregatedStatisticProps } from './types';

export const DistributionEfficiencyAggregatedStatistic = (props: IDistributionEfficiencyAggregatedStatisticProps) => {
  const { value, comparisonValue } = props;

  return (
    <Space size='middle' className={styles.container}>
      {STATISTICS.map(({ key, title }) => {
        const diff = comparisonValue ? round10(value[key] - comparisonValue[key]) : 0;

        return (
          <Card key={key}>
            <Statistic title={title} value={value[key]} suffix='h' precision={1} />
            {comparisonValue && diff !== 0 && (
              <ComparisonValue value={round10(comparisonValue[key])} diff={diff} suffix='h' invertDiff />
            )}
          </Card>
        );
      })}
    </Space>
  );
};
